import { FlexAligner, Typography } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { colors, responsive } from '@/utils';

const horizontalPadding = '1.25rem';
const verticalPadding = responsive.spacing.large;
export const StyledTitle = styled(Typography)<{ $titleZIndex: number }>`
  text-overflow: ellipsis;
  word-break: break-all;

  z-index: ${({ $titleZIndex }) => $titleZIndex};
`;

export const Heading = styled(FlexAligner)`
  padding: ${verticalPadding} ${horizontalPadding} 0;
`;

export const StyledSubtitle = styled(Typography)<{ $titleZIndex: number }>`
  color: ${colors.text.neutral.contrast};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  z-index: ${({ $titleZIndex }) => $titleZIndex};
`;

export const Content = styled.div<{ $flexDirection?: string; $flex?: number }>`
  border-radius: 0.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: ${({ $flexDirection }) => ($flexDirection ? $flexDirection : 'column')};
  flex: ${({ $flex }) => ($flex !== undefined ? $flex : 1)};
  height: 100%;
  justify-content: center;
  overflow: auto;
  padding: ${verticalPadding} ${horizontalPadding} 0;
  width: 100%;
`;

export const StyledFooterBox = styled(FlexAligner)`
  padding: ${verticalPadding} ${horizontalPadding};
`;
